import { Component, Vue } from 'vue-property-decorator';
import offline from 'v-offline';
import { LoggerService } from '@/utils';

@Component({
    components: {
        offline,
    },
})
export default class AboutComponent extends Vue {
    public demoVar: boolean = true;

    public mounted() {
        const placeholder = false;
    }

    public handleConnectivityChange(status: any) {
        LoggerService.LogDebug(status);
    }
}
